import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { CompanyBranding } from '@/utils/branding';

export const useOnboardingStore = defineStore(
  'onboarding',
  () => {
    const uuid = ref('');
    const jobTitleId = ref<number | null>(null);
    const jobTitleLabel = ref('');
    const customJob = ref<string | null>(null);
    const jobWasPreset = ref(false); // true if job_title already set before onboarding started
    // Branding carried over from the register flow, used to set af-session-auth before
    // redirecting to the assessments app (mirrors what af/auth does in get-user-flow.ts).
    const branding = ref<CompanyBranding | null>(null);
    const sharepool = ref<string | null>(null);

    function setUser(userUuid: string) {
      uuid.value = userUuid;
    }

    function setJobTitle(data: { id?: number | null; label: string; custom?: boolean }) {
      if (data.id) {
        jobTitleId.value = data.id;
        customJob.value = null;
      } else {
        jobTitleId.value = null;
        customJob.value = data.label;
      }
      jobTitleLabel.value = data.label;
    }

    function setBranding(value: CompanyBranding | null) {
      branding.value = value;
    }

    function setSharepool(value: string | null) {
      sharepool.value = value;
    }

    function reset() {
      uuid.value = '';
      jobTitleId.value = null;
      jobTitleLabel.value = '';
      customJob.value = null;
      jobWasPreset.value = false;
      branding.value = null;
      sharepool.value = null;
    }

    return {
      uuid,
      jobTitleId,
      jobTitleLabel,
      customJob,
      jobWasPreset,
      branding,
      sharepool,
      setUser,
      setJobTitle,
      setBranding,
      setSharepool,
      reset
    };
  },
  {
    persist: { storage: sessionStorage }
  }
);
